export default "__VITE_ASSET__ba0c9cf4__"